import { StepIndex } from "../types/types";
import __ from "../utils/getContent";
import { useContext, useState } from "react";
import { ApiContext } from "../context/ApiContext";
import MembershipSummary from "./MembershipSummary";
import ChevronDown from "../icons/chevronDown";

const Timeline = ({ currentStep }: { currentStep: StepIndex }) => {
	const { data } = useContext(ApiContext);
	const [showDetails, toggleDetails] = useState(false);

	return (
		<div className="timeline mx-auto mb-10 mt-6 w-full max-w-5xl border border-black px-10 py-3 text-center">
			<div
				className={
					currentStep >= 4
						? "grid grid-cols-[1fr_200px] items-center gap-4"
						: ""
				}
			>
				<div className="relative mx-auto flex w-full max-w-xl justify-between">
					<div className="background-line absolute left-4 right-4 top-[20px] z-0 h-[1px] bg-gray-500"></div>
					<TimelineStep
						text={__("timeline_step_1_label", "Plan")}
						number={1}
						isActive={currentStep >= 2}
					/>
					<TimelineStep
						text={__("timeline_step_2_label", "Summary")}
						number={2}
						isActive={currentStep >= 3}
					/>
					<TimelineStep
						text={__("timeline_step_3_label", "Details")}
						number={3}
						isActive={currentStep >= 4}
					/>
					<TimelineStep
						text={__("timeline_step_4_label", "Payment")}
						number={4}
						isActive={currentStep >= 5}
					/>
				</div>
				{currentStep >= 4 && (
					<button
						onClick={() => toggleDetails(!showDetails)}
						className="flex items-center justify-end gap-2 text-3xl"
					>
						<>${data?.selectedMembership?.Rate}/mo</>
						<div className={showDetails ? "rotate-180" : ""}>
							<ChevronDown />
						</div>
					</button>
				)}
			</div>
			{currentStep >= 4 && showDetails && (
				<div className="mt-12 flex flex-col justify-center self-center text-center">
					<h1 className="mb-6 text-3xl font-bold uppercase">
						{__("membership_summary", "Membership Summary")}
					</h1>
					<MembershipSummary />
				</div>
			)}
		</div>
	);
};

const TimelineStep = ({
	text,
	number,
	isActive,
}: {
	text: string;
	number: Number;
	isActive: boolean;
}) => {
	const circleCssClass = `${
		isActive ? "bg-black" : "bg-gray-timeline"
	} text-xl font-semibold w-10 h-10 rounded-full  text-white flex justify-center items-center`;
	return (
		<div className="w-18 z-10 flex flex-col items-center justify-center">
			<div className={circleCssClass}>{number.toString()}</div>
			<p className="text-sm">{text}</p>
		</div>
	);
};

export default Timeline;
